module.exports = __webpack_public_path__ + "media/game-video.832119f2.mp4";